export const STEPS = ["analyzing", "draft", "test", "ready", "pending_validation", "published"];

export const STATUS = {
  analyzing: { label: "Analyse IA", cls: "bg-[#EFF6FF] text-[#1E3A8A] border-[#BFDBFE]" },
  draft: { label: "Brouillon", cls: "bg-[#F1F3F5] text-[#495057] border-[#DEE2E6]" },
  test: { label: "En test", cls: "bg-[#FFFBEB] text-[#92400E] border-[#FDE68A]" },
  ready: { label: "Prêt à publier", cls: "bg-[#F0FDFA] text-[#115E59] border-[#99F6E4]" },
  pending_validation: { label: "En attente de validation", cls: "bg-[#FFF7ED] text-[#9A3412] border-[#FDBA74]" },
  published: { label: "Publié", cls: "bg-[#ECFDF5] text-[#065F46] border-[#A7F3D0]" },
};

export const SEVERITY = {
  low: { label: "Mineur", cls: "bg-[#F1F3F5] text-[#495057]" },
  normal: { label: "Normal", cls: "bg-[#EFF6FF] text-[#1E3A8A]" },
  high: { label: "Important", cls: "bg-[#FFFBEB] text-[#92400E]" },
  blocking: { label: "Bloquant", cls: "bg-[#FEF2F2] text-[#991B1B]" },
};

export const ISSUE_STATUS = {
  open: { label: "Ouvert", cls: "bg-[#FEF2F2] text-[#991B1B] border-[#FECACA]" },
  fixing: { label: "Correction proposée", cls: "bg-[#F5F3FF] text-[#5B21B6] border-[#DDD6FE]" },
  fixed: { label: "Corrigé · à re-tester", cls: "bg-[#FFFBEB] text-[#92400E] border-[#FDE68A]" },
  verified: { label: "Vérifié", cls: "bg-[#ECFDF5] text-[#065F46] border-[#A7F3D0]" },
  rejected: { label: "Sans suite", cls: "bg-[#F1F3F5] text-[#868E96] border-[#DEE2E6]" },
};

export const TYPE_LABEL = { text: "Texte", textarea: "Texte long", number: "Nombre", money: "Montant €", date: "Date", datetime: "Date & heure", select: "Liste", multiselect: "Choix multiples", bool: "Oui / Non", email: "Email", phone: "Téléphone", url: "Lien", salarie: "Salarié", client: "Client", relation: "Fiche liée", files: "Pièces jointes", formula: "Calculé ƒ" };
export const FORMULA_FORMAT_LABEL = { number: "nombre", money: "montant €", percent: "pourcentage", date: "date", text: "texte", bool: "oui/non" };
export const VIEW_LABEL = { list: "Liste", kanban: "Kanban", calendar: "Calendrier" };
export const KPI_LABEL = { count: "Compteur", sum: "Somme", avg: "Moyenne", overdue: "En retard" };
export const CATEGORY_LABEL = { qualite: "Qualité", rh: "RH", commerce: "Commerce", finance: "Finance", logistique: "Logistique", securite: "Sécurité", production: "Production", maintenance: "Maintenance", sante: "Santé", autre: "Autre" };

export const fmtPrice = (v) => `${Number(v || 0).toLocaleString("fr-FR", { minimumFractionDigits: 0, maximumFractionDigits: 2 })} €`;
export const fmtDT = (v) => (v ? new Date(v).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "—");
export const sizeKo = (b) => (b >= 1024 * 1024 ? `${(b / 1024 / 1024).toFixed(1)} Mo` : `${Math.round((b || 0) / 1024)} Ko`);

export const Badge = ({ cls, children, testid }) => <span className={`inline-flex items-center text-[10px] uppercase tracking-wider font-bold px-2 py-0.5 border ${cls}`} data-testid={testid}>{children}</span>;
